import React from "react";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Stats from "@/components/sections/Stats";
import Brands from "@/components/sections/Brands";
import B2B from "@/components/sections/B2B";
import Quality from "@/components/sections/Quality";
import Clients from "@/components/sections/Clients";

const Home = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <About />
      <Stats />
      <Brands />
      <B2B />
      <Quality />
      <Clients />
    </main>
  );
};

export default Home;
